import {httpGet,httpPut,httpDelete,httpPost,httpPostForm,httpDownload} from '@/util/request.js';
import appConfig from '@/config';


export default class CwBudgetCostApi{
    // static baseUrl = 'http://10.254.121.186:20065' + appConfig.pdServicePath  + "/pd/cw-budget-cost/";
    static baseUrl = appConfig.gatewayUrl + appConfig.pdServicePath  + "/pd/cw-budget-cost/";
    // static exportUrl = 'http://10.254.121.186:20065' + appConfig.pdServicePath  + "/pd/cw-budget-cost/export";
    static exportUrl = appConfig.gatewayUrl + appConfig.pdServicePath  + "/pd/cw-budget-cost/export";
    /**
     * 获取工程预算列表
     * @param param
     * @returns {undefined}
     */
    static projectList(param) {
        return this.httpRequest('list',param,'post');
    }


    static projectListIn(param) {
        return this.httpRequest('listIn',param,'post');
    }


    /**
     * 工程预算详情
     * @param param
     * @returns {undefined}
     */
    static projectDetail(param) {
        return this.httpRequest('detail', param, 'post');
    }

    /**
     * 导出工程预算数据
     * @param param
     * @returns {*}
     */
    static exportStoreOrdersItem(param) {
        return httpDownload(this.exportUrl, param,'get');
    }


    /**
     * 导入预算数据
     * @param param
     * @returns {*}
     */
    static importData(param) {
        let formData = new FormData()
        formData.append('file', param.file);
        formData.append('costId', param.costId);
        return this.httpRequest('import', formData, 'post');
    }

    /**
     * 导出预算导入模板
     * @param param
     * @returns {*}
     */
    static exportTemplate(param) {
        return httpDownload(this.baseUrl + 'exportTemplate', param, 'get');
    }


    /**
     * 预算数据保存
     * @param param
     * @returns {undefined}
     */
    static saveData(param) {
        return this.httpRequest('saveBudgetCostData', param, 'post');
    }


    /**
     * 预算数据提交
     * @param param
     * @returns {*}
     */
    static submitBudget(param) {
        return this.httpRequest('submitBudgetCostData', param, 'post');
    }


    /**
     * 预算集团审批
     * @param param
     * @returns {*}
     */
    static groupAuditBudget(param) {
        return this.httpRequest('groupAuditBudgetCost', param, 'post');
    }


    /**
     * 预算财务审批
     @param param
     @returns {*}
     */
    static financeAuditBudget(param) {
        return this.httpRequest('financeAuditBudgetCost', param, 'post');
    }

    /**
     * 获取物业预算列表
     * @param param
     * @returns {*}
     */
    static propertyList(param) {
        return this.httpRequest('wy/list', param, 'post');
    }


    /**
     * 物业预算详情
     * @param param
     * @returns {undefined}
     */
    static propertyDetail(param) {
        return this.httpRequest('wy/detail', param, 'post');
    }

    /**
     * 导出物业预算数据
     * @param param
     * @returns {*}
     */
    static exportProperty(param) {
        return httpDownload(this.baseUrl + 'wy/export', param,'get');
    }


    static httpRequest(url, param, method ){
        if(method == 'get'){
            return httpGet(this.baseUrl + url, param);
        }
        if(method == 'post'){
            return httpPost(this.baseUrl + url, param);
        }
    }

    static handleResponse(response, scope, successFunc,errorFunc){
        let data = response.data;
        if(data.code == 200){
            if(successFunc && typeof successFunc == 'function'){
                successFunc(data.data);
            }
        }else{
            let text = data.errMsg
            scope.$dialog.error({
                text: text,
                title: "错误"
            });
            if(errorFunc && typeof errorFunc == 'function'){
                errorFunc(data);
            }
        }
    }

    static handleNetworkError(response, scope, errorFunc){
        scope.$dialog.error({
            text: response.message,
            title: "错误"
        });
        if(errorFunc && typeof errorFunc == 'function'){
            errorFunc(response);
        }
    }
}